import { render } from "./UserHome.vue?vue&type=template&id=16b44ec5&scoped=true"
import script from "./UserHome.vue?vue&type=script&lang=js"
export * from "./UserHome.vue?vue&type=script&lang=js"

import "./UserHome.vue?vue&type=style&index=0&id=16b44ec5&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16b44ec5"]])

export default __exports__